import styled from '@emotion/styled';

export const GiftTypeWrap = styled.div``;

export const GiftWrap = styled.div<{
  benefits?: boolean;
  maxWidth?: boolean;
}>`
  display: flex;
  grid-gap: ${props => (props.benefits ? '60px' : '0px')};
  max-width: ${props => (props.maxWidth ? '100%' : '596px')};
  margin: auto;
  align-items: flex-start;
  transition: all 150ms linear;
  @media (max-width: 599px) {
    flex-direction: column;
  }
`;

export const RecipientDetailsWrapper = styled.div`
  max-width: 460px;
  width: 100%;
  margin: auto;

  @media (max-width: 599px) {
    max-width: 100%;
  }
`;
